import { useEffect } from 'react';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { discardPendingOAuthIdentity, fetchPendingOAuthIdentity } from '../../api';
import { trackEvent } from '@/shared/analytics';

const PENDING_IDENTITY_KEY = ['oauth', 'pending'] as const;

export function usePendingOAuthIdentity() {
  const queryClient = useQueryClient();
  const { data: identity } = useQuery({
    queryKey: PENDING_IDENTITY_KEY,
    queryFn: fetchPendingOAuthIdentity,
    retry: false,
    staleTime: Infinity,
  });

  useEffect(() => {
    if (identity) trackEvent('oauth_profile_shown', { provider: identity.provider });
  }, [identity]);

  const forget = () => queryClient.setQueryData(PENDING_IDENTITY_KEY, null);

  const discard = () => {
    forget();
    void discardPendingOAuthIdentity();
  };

  return { identity: identity ?? null, discard, forget };
}
